module.exports = __webpack_public_path__ + "img/signupTop.3a712ce6.svg";